import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { ColorConfigurationSelect } from '../inputs/ColorConfigurationSelect';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { PaintColorValue } from '../readonly/PaintColorValue';
import { ConfigurationComponent } from '.';

const AluCladdingColorConfig = () => (
  <ColorConfigurationSelect
    configurationKey="aluCladdingColor"
    dispatchAction="SET_ALU_CLADDING_COLOR"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'aluCladdingColor'> = {
  key: 'aluCladdingColor',
  input: <AluCladdingColorConfig />,
  display: (value: ConfigurationValues['aluCladdingColor']) => (
    <PaintColorValue value={value} />
  ),
};

export default config;
